import { render } from "./EditMedia.vue?vue&type=template&id=00d38a8c&ts=true"
import script from "./EditMedia.vue?vue&type=script&lang=ts"
export * from "./EditMedia.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__